import { render, staticRenderFns } from "./AddGroupNumber2026.vue?vue&type=template&id=82d63820&scoped=true"
import script from "./AddGroupNumber2026.vue?vue&type=script&lang=js"
export * from "./AddGroupNumber2026.vue?vue&type=script&lang=js"
import style0 from "./AddGroupNumber2026.vue?vue&type=style&index=0&id=82d63820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d63820",
  null
  
)

export default component.exports